export const SET_ESTADOS = "ESTADOS/SET_ESTADOS";
export const SET_ESTADO = "ESTADOS/SET_ESTADO";
export const SET_PAGINATION = "ESTADOS/SET_PAGINATION";
